import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import NavItem from "../../components/SubHeader/NavItem";
import "./SubHeader.css";

function SubHeader() {
  const [isMobileMenuVisible, setIsMobileMenuVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleToggle = () => {
      setIsMobileMenuVisible((prev) => !prev);
    };

    window.addEventListener("toggle-subheader", handleToggle);
    return () => window.removeEventListener("toggle-subheader", handleToggle);
  }, []);

  return (
    <>
      <div className="employee-sub-header desktop-only grouped-layout">

        {/* People Management */}
        <div className="nav-dropdown">
          <button className="dropdown-btn">
            <i className="fa-solid fa-users"></i> People Management
            <i className="fa-solid fa-caret-down dropdown-arrow"></i>
          </button>
          <div className="dropdown-menu">
            <NavItem
              navTitle="Employee Directory"
              navLink="/AdminEmployeeList"
              navIcon="fa-solid fa-id-badge"
            />
            <NavItem
              navTitle="Departments"
              navLink="/Departments"
              navIcon="fa-solid fa-people-group"
            />
            <NavItem
              navTitle="Work Locations"
              navLink="/WorkLocations"
              navIcon="fa-solid fa-location-dot"
            />
          </div>
        </div>

        {/* Attendance */}
        <div className="nav-dropdown">
          <button className="dropdown-btn">
            <i className="fa-solid fa-clock"></i> Time & Attendance
            <i className="fa-solid fa-caret-down dropdown-arrow"></i>
          </button>
          <div className="dropdown-menu">
            <NavItem
              navTitle="Attendance Records (X)"
              navLink="/AdminAttendance"
              navIcon="fa-solid fa-calendar-check"
            />
            <NavItem
              navTitle="Shift Schedules"
              navLink="/ShiftSchedule"
              navIcon="fa-solid fa-business-time"
            />
            <NavItem
              navTitle="Overtime Requests (X)"
              navLink="/AdminOvertime"
              navIcon="fa-solid fa-clock-rotate-left"
            />
            <NavItem
              navTitle="Official Business (X)"
              navLink="/AdminBusiness"
              navIcon="fa-solid fa-briefcase"
            />
          </div>
        </div>

        {/* Payroll */}
        <div className="nav-dropdown">
          <button className="dropdown-btn">
            <i className="fa-solid fa-money-bill-wave"></i> Payroll
            <i className="fa-solid fa-caret-down dropdown-arrow"></i>
          </button>
          <div className="dropdown-menu">
            <NavItem
              navTitle="Payroll Processing (X)"
              navLink="/PayrollRun"
              navIcon="fa-solid fa-file-invoice-dollar"
            />
            <NavItem
              navTitle="Earnings & Deductions"
              navLink="/SalaryRecord"
              navIcon="fa-solid fa-scale-balanced"
            />
            <NavItem
              navTitle="Allowance Types"
              navLink="/AllowanceTypes"
              navIcon="fa-solid fa-plus-circle"
            />
            <NavItem
              navTitle="Deduction Types"
              navLink="/DeductionTypes"
              navIcon="fa-solid fa-minus-circle"
            />
          </div>
        </div>

        {/* System */}
        <div className="nav-dropdown">
          <button className="dropdown-btn">
            <i className="fa-solid fa-gear"></i> System Settings
            <i className="fa-solid fa-caret-down dropdown-arrow"></i>
          </button>
          <div className="dropdown-menu">
            <NavItem
              navTitle="Configuration (X)"
              navLink="/AdminSettings"
              navIcon="fa-solid fa-sliders"
            />
          </div>
        </div>

      </div>
    </>
  );
}

export default SubHeader;
